/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Preview1Inputs */

const vi_cmstools_preview1 = /** @type {(inputs: Cmstools_Preview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem trước trên website`)
};

/**

* @param {Cmstools_Preview1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_preview1 = /** @type {((inputs?: Cmstools_Preview1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Preview1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_preview1(inputs)
});
export { cmstools_preview1 as "cmsTools_preview" }